import BaseAPI from "./../../../../api/baseAPI";
import { client } from "./../../../../api/apiClient";
import routes from "../../../../assets/apiRoutes.json";

class InspectionDetailsApi extends BaseAPI {
    constructor(token) {
        super(token);
    }
    loadBlockCodes = async () => {
        return await client.get(routes.TMLocation.GetAllBlockCodesLookup, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    loadLocationCodes = async (BlockRowid) => {
        return await client.get(routes.TMLocation.GetAllLocationCodesLookup, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params:{
                rowid: BlockRowid
            }
        });
    }
    loadInspectionTypes = async () => {
        return await client.get(routes.Inspection.GetInspectionTypes, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    loadInspectionGridColumns = async (inspectionType) => {
        return await client.get(routes.Inspection.GetInspectionGridColumns, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params:{
                inspectionTypeRowId: inspectionType
            }
        });
    }
    loadRametCodes = async () => {
        return await client.get(routes.Inspection.GetRametCodes, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
        });
    }
    loadInspectionRametCodes = async () => {
        return await client.get(routes.Inspection.GetInspectionRametCodes, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
        });
    }
    loadSavedInspectionDetail = async (inspectionRowid) => {
        return await client.get(routes.Inspection.LoadSavedInspectionDetail, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params:{
                rowid: inspectionRowid
            }
        });
    }
    saveInspectionHeader = async (obj) => {
        return await client.post(routes.Inspection.InsertInspectionHeaderRecord, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    saveInspectionDetail = async (obj) => {
        return await client.post(routes.Inspection.InsertInspectionDetail, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    saveInspectionAssetDetail = async (obj) => {
        return await client.post(routes.Inspection.InsertInspectionAssetDetail, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    deleteInspectionDetail = async (obj) => {
        return await client.post(routes.Inspection.DeleteInspectionDetail, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    loadInspectionQuestions = async (rowid) => {
        return await client.get(routes.Inspection.GetInspectionQuestions, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params:{
                inspectionTypeRowid: rowid
            }
        });
    }
    saveInspectionQuestion = async (obj) => {
        return await client.post(routes.Inspection.InsertInspectionQuestions, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    loadInspectionQuestionsAnswers = async (rmtCdId, inspectionHdrRowid) => {
        return await client.get(routes.Inspection.GetInspectionQuestionsAnswers, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params: {
                rametcoderowid: rmtCdId,
                inspectionrowid: inspectionHdrRowid
            }
        });
    }
    getInspectionId = async () => {
        return await client.get(routes.Inspection.GetInspectionId, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
    loadInspectonDetail = async () => {
        return await client.get(routes.Inspection.LoadInspectionDetail, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
        });
    }
    loadInspectonDetailHistory = async (inspectiontype) => {
        return await client.get(routes.Inspection.LoadAllDetailInspectionHistory, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params: {
                inspectiontype: inspectiontype
            }
        });
    }
    loadInspectionAnswers = async (InspectionDetailRowid) => {
        return await client.get(routes.Inspection.GetInspectionAnswers, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            },
            params: {
                inspectiondetailrowid: InspectionDetailRowid
            }
        });
    }
    saveInspectionDetailV2 = async (obj) => {
        return await client.post(routes.Inspection.InsertInspectionQuestionsV2, obj, {
            headers: {
                access_token: this.token,
                Authorization: `Bearer ${this.token}`,
            }
        });
    }
}

export default InspectionDetailsApi;